'use client'

import Button from '@dd3tech/wiggui/Button'
import GoogleIcon from '@dd3tech/wiggui/GoogleIcon'
import Input from '@dd3tech/wiggui/Input'
import Modal from '@dd3tech/wiggui/Modal'
import { useModalSearchId } from './hooks/useModalSearchId'
import { SearchHomeSvg } from '../../svg'

export const ModalSearchId = () => {
  const {
    handleOnClick,
    isLoading,
    modalSearchIdIsOpen,
    onClose,
    searchId,
    setSearchId
  } = useModalSearchId()

  if (!modalSearchIdIsOpen) {
    return null
  }

  return (
    <Modal
      className="w-full max-w-lg"
      enableBgBlur
      onClose={isLoading ? () => ({}) : onClose}
      isOpen={modalSearchIdIsOpen}
    >
      <Modal.Header title="Buscar por ID" isShowCloseButton isShowDivider />
      <Modal.Body className="p-6 w-full flex gap-6 flex-col items-center justify-center">
        <SearchHomeSvg />
        <Input
          name="id-property"
          value={searchId}
          onChange={(event) => setSearchId(event?.target.value)}
          className="w-full"
          height="h-[52px]"
          classNameContainer="w-full"
          classNameLabel="text-secondary"
          labelText="Ingresa el ID de la propiedad"
          leftIcon={
            <GoogleIcon name="search" className="text-primary text-[24px]" />
          }
        />
      </Modal.Body>
      <Modal.Footer className="w-full py-[9px] px-6" isShowDivider>
        <Button
          isLoading={isLoading}
          onClick={handleOnClick}
          isDisabled={searchId?.length <= 3}
          variant="secondary"
          fullWidth
        >
          Buscar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
